/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PageBackButton from "@/components/PageBackButton";
import WinRateCalculator from "./WinRateCalculator";

export default function WinRateCalculatorPage() {
  return (
    <div className="p-6">
      <div className="mx-auto mb-4 max-w-4xl">
        <PageBackButton label="Back to Research" to="/research" preferHistory={false} hideLabelOnMobile />
      </div>
      <Card className="max-w-4xl mx-auto">
        <CardHeader>
          <CardTitle>Win-Rate Calculator</CardTitle>
        </CardHeader>
        <CardContent>
          <WinRateCalculator />
        </CardContent>
      </Card>
    </div>
  );
}
